<template>
  <section
    v-if="shopifyData.show_section == 'true'"
    class="all_feature_bag_sec blog_shop_all_bags"
    :style="{ backgroundColor: backgroundColor }"
  >
    <div class="container">
      <h3 class="card_heading" v-html="shopifyData.section_heading" />
      <!-- Sec Content -->
      <div class="sec_content">
        <div class="product_cards">
          <div
            v-for="(item, index) in shopifyData.product_data.slice(0, 4)"
            :key="index"
            class="card"
          >
            <a
              :href="item.product.product_url"
              :product-id="item.product.product_id"
              class="product_link"
            >
              <img
                v-lazy="item.product.product_image"
                :alt="item.product.product_image.alt || 'Product Image'"
                loading="lazy"
                aria-hidden="true"
                aria-label="Product Image"
                height="348"
                width="348"
                class="product_image"
              />
              <div class="product_info">
                <p class="subtitle" v-html="item.product.product_title" />
                <div>
                  <div class="card-title tmb_product_price bold product_price">
                    <span
                      v-if="Number(item.product.product_compare_price) > 0"
                      class="tmb_original_price"
                    >
                      {{ currencySymbol
                      }}{{
                        currencySymbol == '€'
                          ? Number(item.product.product_price.toString().replace(',', '.')).toFixed(
                              2
                            )
                          : item.product.product_price
                      }}

                      <del> {{ currencySymbol }}{{ item.product.product_compare_price }} </del>
                    </span>

                    <span v-else class="tmb_original_price">
                      {{ currencySymbol
                      }}{{
                        currencySymbol === '€'
                          ? Number(item.product.product_price.toString().replace(',', '.')).toFixed(
                              2
                            )
                          : item.product.product_price
                      }}
                    </span>
                  </div>
                </div>
              </div>
            </a>
          </div>
        </div>
        <div class="product_cards tmb-md-none">
          <div v-for="(item, index) in shopifyData.product_data.slice(4)" :key="index" class="card">
            <a
              :href="item.product.product_url"
              :product-id="item.product.product_id"
              class="product_link"
            >
              <img
                v-lazy="item.product.product_image"
                :alt="item.product.product_image.alt || 'Product Image'"
                loading="lazy"
                aria-hidden="true"
                aria-label="Product Image"
                height="348"
                width="348"
                class="product_image"
              />
              <div class="product_info">
                <p class="subtitle" v-html="item.product.product_title" />
                <div>
                  <div class="card-title tmb_product_price bold product_price">
                    <span
                      v-if="Number(item.product.product_compare_price) > 0"
                      class="tmb_original_price"
                    >
                      {{ currencySymbol
                      }}{{
                        currencySymbol == '€'
                          ? Number(item.product.product_price.toString().replace(',', '.')).toFixed(
                              2
                            )
                          : item.product.product_price
                      }}

                      <del> {{ currencySymbol }}{{ item.product.product_compare_price }} </del>
                    </span>

                    <span v-else class="tmb_original_price">
                      {{ currencySymbol
                      }}{{
                        currencySymbol === '€'
                          ? Number(item.product.product_price.toString().replace(',', '.')).toFixed(
                              2
                            )
                          : item.product.product_price
                      }}
                    </span>
                  </div>
                </div>
              </div>
            </a>
          </div>
        </div>
        <div class="cta_link t-center">
          <button class="cta_btn" @click="showproducts">
            <svg
              width="32"
              height="18"
              viewBox="0 0 32 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1 1.5L16 16.5L31 1.5"
                stroke="#A4A4A4"
                stroke-width="2"
                stroke-linejoin="round"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { currencyJson } from '@/currency';
import { formatPrice } from '@/utils/formatPrice';

export default {
  props: {
    shopifyData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      currencySymbol: currencyJson[window?.Shopify?.currency?.active]?.symbol_native,
      formatPrice,
    };
  },
  computed: {
    backgroundColor() {
      return window.innerWidth <= 768
        ? this.shopifyData.sectionColorMob
        : this.shopifyData.sectionColorDesktop;
    },
  },
  mounted() {
    this.currencySymbol = currencyJson[window?.Shopify?.currency?.active]?.symbol_native;
  },

  methods: {
    showproducts() {
      const productRows = document.querySelectorAll('.product_cards.tmb-md-none');
      const rowBtn = document.querySelector('.sec_content .cta_btn');

      productRows.forEach((pr) => {
        if (pr.classList.contains('show')) {
          pr.style.maxHeight = '0px';
          pr.classList.remove('show');
        } else {
          pr.classList.add('show');

          // actual height calculate
          const height = pr.scrollHeight;
          pr.style.maxHeight = height + 'px';
        }
      });

      rowBtn.classList.toggle('rotate');
    },
  },
};
</script>
<style scoped>
.all_feature_bag_sec {
  padding: 0 15px 84px;
}

.all_feature_bag_sec .container {
  padding-top: 39.5px;
}
.container {
  max-width: 1410px;
  margin: 0 auto;
}

.card_heading {
  margin-bottom: 17px;
  border-top: 1px solid #000;
  padding-top: 32px;
}

.product_info {
  margin-top: 6px;
}

.product_cards {
  display: grid;
  gap: 34px 6px;
  justify-content: center;
  grid-template-columns: repeat(4, 1fr);
}

.card > a {
  display: block;
}

.product_cards:not(:last-child) {
  padding-bottom: 34px;
}

.cta_link {
  margin-top: 30px;
}

.cta_btn {
  padding: 0;
}

.product_btn .cta_btn {
  padding: 10px 26px;
  background: #fff;
  color: #000;
  border: 1px solid #000;
}

.product_btn .cta_btn:hover {
  background: #000;
  color: #fff;
  border: 1px solid transparent;
}

/* Responsive Breakpoints */
@media (max-width: 1350px) {
  .product_btn .cta_btn {
    padding: 10px;
  }
}

@media (max-width: 1250px) {
  .product_varients {
    gap: 10px;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    margin-top: 10px;
  }
}

@media (max-width: 767px) {
  .all_feature_bag_sec {
    padding: 35px 0 31px 2px;
  }
  .all_feature_bag_sec .container {
    padding-top: 0;
  }

  .card_heading {
    margin: 0 12px 6px 12px;
    padding-top: 10px;
  }

  .product_cards {
    gap: 2px;
    justify-content: unset;
    display: flex;
  }

  .card {
    min-width: 166px;
  }

  .product_info {
    margin: 8px 0 0 4px;
  }

  .sec_content {
    overflow-x: scroll;
    display: flex;
    gap: 2px;
  }

  .subtitle,
  .subtitle_b {
    font-size: 10px;
    line-height: 12px;
  }

  .card > a {
    max-width: 166px;
  }

  .subtitle {
    margin-bottom: 7px;
  }

  .product_cards:not(:last-child) {
    padding-bottom: 20px;
  }

  .cta_link.t-center {
    display: none;
  }

  .product_cards.tmb-md-none.show {
    height: 0;
  }

  .product_varients {
    display: none;
  }
  .product_image {
    height: 166px;
    width: 166px;
  }
}

@media (min-width: 768px) {
  .product_cards.tmb-md-none {
    opacity: 0;
    visibility: hidden;
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.4s ease;
  }

  .product_cards.tmb-md-none.show {
    opacity: 1;
    visibility: visible;
    overflow: visible;
  }
  .product_image {
    width: 100%;
    height: auto;
    display: block;
  }

  .product_cards.tmb-md-none.show + .cta_link {
    margin-top: 84px;
    transform: rotate(180deg);
  }

  .cta_btn {
    transition: 0.4s;
  }
}
</style>
